import { GetMemberPasswordResetTokenRequest } from './../../../models/ss-api/requests/get.member.password.reset.token.request';

import { SelectItem } from 'primeng/primeng';
import { OnInit, OnDestroy, Component, Input, Output, EventEmitter, AfterViewInit, OnChanges } from '@angular/core';
import { MemberDashboard } from '../../../models/ss-api/responses/member.dashboard.response';
import { EmailTemplateBasicsItemArray } from '../../../models/domain/email.template.basics.item';
import { TemplateTypes } from '../../../models/domain/email.template.item';
import { ssApiService } from '../../../services/ss-api.service';
import { IBaseResponse } from '../../../models/comm-http/responses/BaseResponse';
import { xToastr, ToastrTypes } from '../../Toastr';
import { EmailTemplateFullItem } from '../../../models/domain/email.template.full.item';
import { GlobalService } from '../../../services/global.service';
import { LicenseFullResponse } from '../../../models/ss-api/responses/license.full.response';
import { BillingCycleTypes } from '../../../models/domain/invoice';
import { License } from '../../../models/domain/license';
import { MemberDashboardLicenseResponseArray } from '../../../models/ss-api/responses/member.dashboard.license.response';
import { TrainingEvent } from '../../../../app/models/domain/training.event';
import { PreviewEmailsForTrainingEventRequest } from '../../../../app/models/ss-api/requests/preview.emails.for.training.event.request';
import { TrainingEmailEventTypes } from '../../../models/ss-api/requests/training.email.event.types';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

// import moment = require('moment');
import * as moment from 'moment';
import { forEach } from '@angular/router/src/utils/collection';


@Component({
  selector: 'template-selection',
  templateUrl: './template.selection.component.html',
  styleUrls: ['./template.selection.component.css']
})
export class TemplateSelectionComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  // inputs
  @Input('IsActive') IsActive: boolean = false;
  @Input('MemberID') MemberID: any;
  @Input('MemberData') MemberData: MemberDashboard;
  @Input('EmailTemplates') EmailTemplates: EmailTemplateBasicsItemArray;
  @Input('TrainingEvent') TrainingEvent: TrainingEvent;
  @Input('NotificationGroupType') TrainingEmailEventType: TrainingEmailEventTypes;
  @Input('TemplateID') TemplateID: number;

  // events
  @Output('UpdateTemplate') UpdateTemplate = new EventEmitter();
  @Output('UpdateEmailAddress') UpdateEmailAddress = new EventEmitter();
  @Output('UpdateSubject') UpdateSubject = new EventEmitter();
  @Output('UpdateSelectedTemplate') UpdateSelectedTemplate = new EventEmitter();
  @Output('Close') Close = new EventEmitter();

  // OTHER VARIABLES
  IsBusy: boolean = true;

  CustomerServiceTemplates: EmailTemplateBasicsItemArray;
  SystemTemplates: EmailTemplateBasicsItemArray;
  TechSupportTemplates: EmailTemplateBasicsItemArray;
  TrainingTemplates: EmailTemplateBasicsItemArray;

  selectedEmailTemplate: string;

  SearchTerm: string = '';

  EmailAddress: string = '';

  licenses: SelectItem[];
  selectedLicense: string;

  selectedLicenseIndex: number = 0;

  FirstName: string = 'mike';
  LastName: string = 'monkey';

  MemberName: string = 'member name';

  CompanyName: string = 'company name';

  isTraining: boolean = false;

  constructor( private api: ssApiService, private gb: GlobalService, private sweetAlert: SweetAlertService ) { }

  ngOnDestroy(): void {

  }

  ngOnInit(): void {
    this.SetUp();
  }

  ngAfterViewInit(): void {
    // throw new Error("Method not implemented.");
  }

  ngOnChanges() {
    this.SetUp();
  }

  SetUp() {
    this.EmailAddress = this.MemberData.Email;
    this.FirstName = this.MemberData.FirstName;
    this.LastName = this.MemberData.LastName;
    this.MemberName = this.MemberData.FirstName + ' ' + this.MemberData.LastName;
    this.CompanyName = this.MemberData.Company;

    this.setUpLicenseDropdown();
    this.setUpTemplateArrays();

    this.IsBusy = false;
  }

  setUpLicenseDropdown( ) {
    this.licenses = [];
    if (this.MemberData.OwnLicenses && this.MemberData.DesignersLicenses) {
      console.log("ownlic", this.MemberData.OwnLicenses);
      let SortableLicenses: MemberDashboardLicenseResponseArray = new MemberDashboardLicenseResponseArray();
      //...this.MemberData.OwnLicenses.concat(this.MemberData.DesignersLicenses)
      this.MemberData.OwnLicenses.forEach(function (license) {
        if (license.Status <= 1 && license.IsAssigned)
          SortableLicenses.push(license);
      });
      this.MemberData.OwnLicenses.forEach(function (license) {
        if (license.Status <= 1 && !license.IsAssigned)
          SortableLicenses.push(license);
      });
      this.MemberData.OwnLicenses.forEach(function (license) {
        if (license.Status > 1 && license.IsAssigned)
          SortableLicenses.push(license);
      });
      this.MemberData.OwnLicenses.forEach(function (license) {
        if (license.Status > 1 && !license.IsAssigned)
          SortableLicenses.push(license);
      });

      this.MemberData.DesignersLicenses.forEach(function (license) {
        if (license.Status <= 1 && license.IsAssigned)
          SortableLicenses.push(license);
      });
      this.MemberData.DesignersLicenses.forEach(function (license) {
        if (license.Status <= 1 && !license.IsAssigned)
          SortableLicenses.push(license);
      });
      this.MemberData.DesignersLicenses.forEach(function (license) {
        if (license.Status > 1 && license.IsAssigned)
          SortableLicenses.push(license);
      });
      this.MemberData.DesignersLicenses.forEach(function (license) {
        if (license.Status > 1 && !license.IsAssigned)
          SortableLicenses.push(license);
      });
      /*
      SortableLicenses.sort((left, right) => {
        if (left.Status > right.Status) {
          return 1;
        } else {
          return -1;
        }
      })
      */

      SortableLicenses.forEach(e => {
        this.licenses.push({ label: e.MemberFirstName + ' ' + e.MemberLastName + ' ' + e.Key, value: e.Key });
      })
    }

    if ( this.licenses.length == 0 ) {
      this.licenses.push( { label: 'No Registered License Keys Found', value: 'No Registered License Keys Found' } );
    }

    this.selectedLicense = this.licenses[0].value;
  }

  setUpTemplateArrays( newTemplates: EmailTemplateBasicsItemArray = this.EmailTemplates ) {
    // TemplateTypes
    this.CustomerServiceTemplates = new EmailTemplateBasicsItemArray();
    this.SystemTemplates = new EmailTemplateBasicsItemArray();
    this.TechSupportTemplates = new EmailTemplateBasicsItemArray();
    this.TrainingTemplates = new EmailTemplateBasicsItemArray();

    this.EmailTemplates = newTemplates;

    if ( newTemplates != undefined && newTemplates.length > 0 ) {
      newTemplates.forEach(e => {
        if ( e.TemplateType == TemplateTypes.CustomerService )
          this.CustomerServiceTemplates.push( e );
        else if ( e.TemplateType == TemplateTypes.System )
          this.SystemTemplates.push( e );
        else if ( e.TemplateType == TemplateTypes.TechSupport )
          this.TechSupportTemplates.push( e );
        else if ( e.TemplateType == TemplateTypes.Training )
          this.TrainingTemplates.push( e );
      });
    }

    this.CustomerServiceTemplates = this.sortByName( this.CustomerServiceTemplates );
    this.SystemTemplates = this.sortByName( this.SystemTemplates );
    this.TechSupportTemplates = this.sortByName( this.TechSupportTemplates );
    this.TrainingTemplates = this.sortByName( this.TrainingTemplates );

    if (this.TrainingEmailEventType) {
      this.TrainingTemplates.forEach(function(template) {
        if (this.GetEventTypeForEmail(String(template.ID)) == this.TrainingEmailEventType) {
          this.selectedEmailTemplate = String(template.ID);
          this.updateEmailTemplate();
        }
      }, this)
    } else if (this.TemplateID) {
      this.selectedEmailTemplate = String(this.TemplateID);
      this.updateEmailTemplate();
    }
  }

  sortByName(sortThis: EmailTemplateBasicsItemArray, ): EmailTemplateBasicsItemArray {
    sortThis.sort((a, b) => a.Name.localeCompare(b.Name));
    return sortThis;
  }

  updateEmailTemplate() {

    this.IsBusy = true;

    if ( this.MemberData && this.MemberData.ID && this.TrainingEvent == undefined ) {
      this.getTemplateForMember();
    } else if ( this.TrainingEvent.ID ) {
      this.getTemplateForTrainingEvent();
    }

  }

  getTemplateForTrainingEvent() {
    let request: PreviewEmailsForTrainingEventRequest = new PreviewEmailsForTrainingEventRequest();
    request.TrainingEmailEventType = this.GetEventTypeForEmail(this.selectedEmailTemplate);
    request.TrainingEventID = this.TrainingEvent.ID;
    this.UpdateSelectedTemplate.emit(this.selectedEmailTemplate)
    let disposable = this.api.PreviewEmailsForTrainingEvent(request).subscribe(response => {
      if (response.Result) {
        this.UpdateSubject.emit(response.Data.RenderedEmailSubject);
        this.UpdateTemplate.emit(response.Data.RenderedEmailBody);
        if (this.MemberData.ID) {
          this.UpdateEmailAddress.emit([this.MemberData.Email]);
        } else {
          this.UpdateEmailAddress.emit(response.Data.Receipients);
        }

        this.Close.emit();
      } else {
        this.sweetAlert.swal({
            type: 'warning',
            title: 'Unable to load template',
            text: response.Message
        })
      }
      disposable.unsubscribe();
      this.IsBusy = false;
    })
  }

  getTemplateForMember() {
    let subscription = this.api.GetEmailTemplateHTML( parseInt(this.selectedEmailTemplate) ).subscribe(

      async (result: IBaseResponse<EmailTemplateFullItem>) => {
        subscription.unsubscribe();

        let LicenseData: LicenseFullResponse = new LicenseFullResponse; // = await this.api.LicenseFull( this.selectedLicense.value );

        if ( !this.selectedLicense.includes('No') ) {
          await this.api.LicenseFull( this.selectedLicense ).toPromise()
            .then(response => {
              LicenseData = response.Data;
            }).catch(error => {
              return;
            });
        } else {
          LicenseData.License = new License();
          LicenseData.License.ProductName = 'No Product Found';
          LicenseData.License.Key = 'No License Key Found';
          LicenseData.License.BillingCycle = BillingCycleTypes.NotDefined;
          LicenseData.License.DateTimeCreated = new Date();
          LicenseData.License.DateTimeTransferedTo = new Date();
          LicenseData.License.DateTimeUpdated = new Date();
          LicenseData.License.NextBillingDate = new Date();
          LicenseData.License.SoftwareVersion = 'No Product Found';
        }

        let newSubject: string = await this.emailReplaceStrings(result.Data.Subject, LicenseData);
        let newEmailTemplate: string = await this.emailReplaceStrings(result.Data.Body, LicenseData);

        this.UpdateTemplate.emit( newEmailTemplate );
        this.UpdateEmailAddress.emit( this.EmailAddress );
        this.UpdateSubject.emit( newSubject );

        this.IsBusy = false;

        this.Close.emit();
      },

      (error: any) => {
        subscription.unsubscribe();

        xToastr.ShowToast(ToastrTypes.Error, error.FriendlyTitle, error.FriendlyMessage);
        this.IsBusy = false;
        this.Close.emit();
      });
  }

  GetEventTypeForEmail(template: string) {
    let temp = this.TrainingTemplates.filter(t => t.ID == parseInt(template))[0];
    let notificationGroupType;

    if (temp.Name.includes('Reminder')) {
      notificationGroupType = TrainingEmailEventTypes.Training_Event_Reminder;
    } else if (temp.Name.includes('NoShows')) {
      notificationGroupType = TrainingEmailEventTypes.Training_Event_NoShows;
    } else if (temp.Name.includes('Certificate')) {
      notificationGroupType = TrainingEmailEventTypes.Training_Event_Certificate;
    } else if (temp.Name.includes('Setup')) {
      notificationGroupType = TrainingEmailEventTypes.Training_Event_Setup;
    }

    return notificationGroupType;
  }

  cancelEmailTemplate() {
    this.Close.emit();
  }

  // --------------------------------------------------
  // Email template String replacement

  async GeneratePasswordResetToken() {
    let request: GetMemberPasswordResetTokenRequest = {
      Email : this.MemberData.Email
    }
    return this.api.GetResetPasswordToken(request).toPromise();
  }

  async emailReplaceStrings( emailString: string, LicenseData: LicenseFullResponse ) {

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    let myLicense = LicenseData.License;

    // OUR NEW REGEX MAP
    let emailStringMap = new Map();

    if (parseInt(this.selectedEmailTemplate) == 241) {
      await this.GeneratePasswordResetToken().then((response) => {
        emailStringMap.set( /{password_reset_link}/g, response.Data);
        emailStringMap.set( /{.password_reset_link}/g, response.Data);
      });
    }

    // NAMES
    emailStringMap.set( /{member_first_name}/g, this.FirstName );
    emailStringMap.set( /{Member.FirstName}/g, this.FirstName );

    emailStringMap.set( /{member_last_name}/g, this.LastName );
    emailStringMap.set( /{Member.LastName}/g, this.LastName );

    emailStringMap.set( /{member_full_name}/g, this.FirstName + ' ' + this.LastName );
    emailStringMap.set( /{Member.FullName}/g, this.FirstName + ' ' + this.LastName );


    emailStringMap.set( /{designer_full_name}/g, myLicense.MemberName );
    emailStringMap.set( /{.designer_full_name}/g, myLicense.MemberName );

    // CONTACT INFO
    emailStringMap.set( /{member_email}/g, this.EmailAddress ); // {$email}
    emailStringMap.set( /{Member.Email1}/g, this.EmailAddress ); // {$email}



    // PRODUCT VARIABLES
    emailStringMap.set( /{license_key}/g, this.selectedLicense ); // {$cd_key}
    emailStringMap.set( /{License.Key}/g, this.selectedLicense ); // {$cd_key}

    emailStringMap.set( /{product_name}/g, myLicense.ProductName);
    emailStringMap.set( /{Product.Name}/g, myLicense.ProductName);

    emailStringMap.set( /{product_price}/g, '$' + myLicense.ProductRecurringAmount); // Product Price
    emailStringMap.set( /{.product_price}/g, '$' + myLicense.ProductRecurringAmount); // Product Price


    // BILLING CYCLE
    let BillingCycle = myLicense.BillingCycle == BillingCycleTypes.Annually ? 'Yearly' : 'Monthly';
    let BillingPeriod = myLicense.BillingCycle == BillingCycleTypes.Annually ? 'Year' : 'Month';

    emailStringMap.set( /{billing_cycle}/g, BillingCycle); // Billing Cycle in "Monthly" or "Yearly"
    emailStringMap.set( /{.billing_cycle}/g, BillingCycle); // Billing Cycle in "Monthly" or "Yearly"

    emailStringMap.set( /{billing_period}/g, BillingPeriod); // Billing Cycle in "Month" or "Year"
    emailStringMap.set( /{.billing_period}/g, BillingPeriod); // Billing Cycle in "Month" or "Year"


    // INVOICES
    emailStringMap.set( /{\$invoice_name}/g, '<span style="color:red">NEED INVOICE NAME</span>'); // {$invoice_name}

    // DATES ETC
    // emailStringMap.set( /DATE/g, '<span style="color:red">NEED DATE</span>' ); // not specific enough
    emailStringMap.set( /{todays_date}/g, moment().format('MMMM Do, YYYY') ); // {$date} -- TODAY'S DATE
    emailStringMap.set( /{DateNow}/g, moment().format('MMMM Do, YYYY') ); // {$date} -- TODAY'S DATE
    emailStringMap.set( /{DateNow.Format\(MM\/dd\/yyyy\)}/g, moment().format('MMMM Do, YYYY') ); // {$date} -- TODAY'S DATE
    emailStringMap.set( /{DateNow.Format\(MMMM dd yyyy\)}/g, moment().format('MMMM Do, YYYY') ); // {$date} -- TODAY'S DATE
    

    console.log(myLicense);

    console.log(emailStringMap.get(/{next_billing_date}/g));

    emailStringMap.set( /{next_billing_date}/g, myLicense.NextBillingDate.getMonth() + 1 + '/' + myLicense.NextBillingDate.getDate() + '/' + myLicense.NextBillingDate.getFullYear() ); // -- Next Billing Date
    emailStringMap.set( /{.next_billing_date}/g, myLicense.NextBillingDate.getMonth() + 1 + '/' + myLicense.NextBillingDate.getDate() + '/' + myLicense.NextBillingDate.getFullYear() ); // -- Next Billing Date

    emailStringMap.set( /{date}/g, new Date().getMonth() + 1 + '/' + new Date().getDate() + '/' + new Date().getFullYear() ); // {$date} -- TODAY'S DATE
    emailStringMap.set( /{.date}/g, new Date().getMonth() + 1 + '/' + new Date().getDate() + '/' + new Date().getFullYear() ); // {$date} -- TODAY'S DATE
    emailStringMap.set( /{purchase_date}/g, myLicense.DateTimeCreated.getMonth() + 1 + '/' + myLicense.DateTimeCreated.getDate() + '/' + myLicense.DateTimeCreated.getFullYear() ); // -- Date product purchased
    emailStringMap.set( /{.purchase_date}/g, myLicense.DateTimeCreated.getMonth() + 1 + '/' + myLicense.DateTimeCreated.getDate() + '/' + myLicense.DateTimeCreated.getFullYear() ); // -- Date product purchased

    emailStringMap.set( /{billing_day_date}/g, this.GetDayOfMonth( myLicense.NextBillingDate ) );
    emailStringMap.set( /{.billing_day_date}/g, this.GetDayOfMonth( myLicense.NextBillingDate ) );

    if (LicenseData.License.BillingCycle == BillingCycleTypes.Monthly) {
        emailStringMap.set( /{billing_day}/g, moment(myLicense.NextBillingDate).format('Do') );
    } else {
        emailStringMap.set( /{billing_day}/g, moment(myLicense.NextBillingDate).format('Do') + ' of ' + months[myLicense.NextBillingDate.getMonth()] );
    }

    if (LicenseData.License.BillingCycle == BillingCycleTypes.Monthly) {
        emailStringMap.set( /{.billing_day}/g, moment(myLicense.NextBillingDate).format('Do') );
    } else {
        emailStringMap.set( /{.billing_day}/g, moment(myLicense.NextBillingDate).format('Do') + ' of ' + months[myLicense.NextBillingDate.getMonth()] );
    }    

    // yesterday.setDate(date.getDate() - 1);
    let endDate: Date = myLicense.NextBillingDate;
    endDate.setDate( endDate.getDate() - 1 );
    emailStringMap.set( /{product_end_date}/g, endDate.getMonth() + 1 + '/' + endDate.getDate() + '/' + endDate.getFullYear() ); // -- Next Billing Date
    emailStringMap.set( /{.product_end_date}/g, endDate.getMonth() + 1 + '/' + endDate.getDate() + '/' + endDate.getFullYear() ); // -- Next Billing Date
    
    //EndDate affects the original variable.  We must set it back, or else each call to this function returns one date earlier
    endDate.setDate( endDate.getDate() + 1 );

    // SOFTWARE DOWNLOAD LINK
    emailStringMap.set( /{software_download_link}/g, 'http://download.structurestudios.com/Version2/SSDownloader.exe' );
    emailStringMap.set( /{.software_download_link}/g, 'http://download.structurestudios.com/Version2/SSDownloader.exe' );

    // SIGNATURE
    emailStringMap.set( /{\$signature}/g, this.gb.FullName + '<br>Structure Studios<br>(800) 778-8996' );
    emailStringMap.set( /{\$signature}/g, this.gb.FullName + '<br>Structure Studios<br>(800) 778-8996' );

    emailStringMap.set( /{LoggedinUserEmailSignature}/g, localStorage.getItem('crm_HTMLEmailSignature') );
    emailStringMap.set( /{Admin.HTMLEmailSignature}/g, localStorage.getItem('crm_HTMLEmailSignature') );


    // COMPANY INFO
    emailStringMap.set( /~Company.HTMLCanSpamAddressBlock~/g, 'Structure Studios | 3300 St Rose Parkway, Suite 310 | Henderson NV, 89052' ); // ~Company.HTMLCanSpamAddressBlock~

    // UGLY GUNK
    emailStringMap.set( /~HostedEmail.Link~/g, '' ); // ~HostedEmail.Link~
    emailStringMap.set( /~OptOut_8~/g, '' );

    // //////////////////////////////////////////////////////////////
    // UPDATE ALL THE STRINGS USING OUR MAP
    // //////////////////////////////////////////////////////////////
    emailStringMap.forEach(function (newString, old) {
      emailString = emailString.replace(old, newString);
    });

    // DONE
    return emailString
  }

  GetDayOfMonth( myDate: Date ): string {
    let dayOfMonth: string = moment(myDate).format('Do').toString();
    return dayOfMonth;
  }

  testFunction() {

  }

}
